import RankList from '~/components/ui/RankList';
export default defineComponent({
  name: 'BlockRankList3LevelsStandard',
  components: {
    RankList: RankList
  },
  props: {
    title: String,
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    classes: {
      type: Object,
      default: function _default() {}
    }
  }
});